import React, { useEffect } from "react";
import TopNavigationBar from "../components/header";
import Footer from "../components/footer";
import InvalidStateModal from "../components/invalid-state-modal/InvalidStateModal";
import { Outlet, useLocation } from "react-router-dom";
import { LineOfBusiness } from "src/app/types";
import { setLineOfBusiness } from "src/app/appSlice";
import { useAppDispatch } from "src/redux/hooks";

const HomePage = () => {
  const urlParams = useLocation();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (urlParams) {
      let lineOfBusiness = LineOfBusiness.WORKERS_COMPENSATION;
      if (urlParams.pathname.includes("/cargo")) {
        lineOfBusiness = LineOfBusiness.CARGO;
      } else if (urlParams.pathname.includes("/ipl")) {
        lineOfBusiness = LineOfBusiness.IPL;
      }
      dispatch(setLineOfBusiness(lineOfBusiness));
    }
  }, [urlParams]);

  return (
    <React.Fragment>
      <TopNavigationBar />
      <InvalidStateModal />
      <Outlet />
      <Footer />
    </React.Fragment>
  );
};
export default HomePage;
